<script setup lang="ts">
import { propTypes } from '@/utils/propTypes';
import { useSlots } from 'vue';

const slots = useSlots()

defineProps({
  titleHeight: propTypes.string.def('50px'),
  showFooter: propTypes.bool.def(true),
  footerHeight: propTypes.string.def('48px'),
  title: propTypes.string.def(''),
  showUnderFooter: propTypes.bool.def(false),
  underFooterH:propTypes.string.def('116px'),
})
</script>

<template>
  <div class="h-full flex flex-col justify-between spm-card bg-[var(--c-crd-bg)] text-[var(--c-txt)]">
    <div
      class="flex items-center justify-between px-[16px] bg-[var(--c-card-title-bg-gray)]"
      :style="{height: titleHeight}">
      <span class="font-bold text-[var(--c-txt)] text-[14px]">{{title}}</span>
      <div>
        <slot name="title">
        </slot>
      </div>
    </div>
    <div v-if="slots.default" class='flex-1 overflow-y-auto'>
      <slot></slot>
    </div>
    <div v-if="showFooter" class="flex items-center px-[16px] bg-[var(--c-crd-foot-bg)] border-t-1px" :style="{height: footerHeight}">
      <slot name="footer"></slot>
    </div>
    <div
      v-if="showUnderFooter" 
      class="flex justify-between items-center px-[16px] bg-[var(--c-dark-bg)] border-t-1px" 
      :style="{height: underFooterH}">
      <slot name="underFooter"></slot>
    </div>    
  </div>
</template>

<style lang="less" scoped>
</style>